export const FETCH_ATTENDANCE_DETAILS = "FETCH_ATTENDANCE_DETAILS";
export const EDIT_ATTENDANCE_DETAILS = "EDIT_ATTENDANCE_DETAILS";
export const MARK_ABSENT = "MARK_ABSENT";
export const MARK_PRESENT = "MARK_PRESENT";
export const MARK_HOLIDAY = "MARK_HOLIDAY";
